import ErrorFormatService from '../../../services/error-format-service';
import { VERIFICATION_TYPE_AUTHENTICATOR_APP_OTP } from '../../../constants/entity/verification-types';
import {
  GET_USER_SETTINGS_DATA_SUCCESS, SAVE_USER_SETTINGS_DATA, SAVE_USER_SETTINGS_DATA_SUCCESS,
  SAVE_USER_SETTINGS_DATA_ERROR, RESET_USER_SETTINGS_DATA, GET_LIST_CONTACT_COMPANY_DATA_SUCCESS,
  GET_LIST_DEAL_DATA_SUCCESS, SEND_PHONE_VERIFICATION_CODE_SUCCESS, GET_USER_API_KEY_SUCCESS, RESET_USER_API_KEY,
  LOGIN_USER_SUCCESS, LOGOUT_USER_SUCCESS, RESET_FORM_ERRORS, GET_OTP_SECRET_DATA_SUCCESS,
  GENERATE_OTP_SECRET_DATA_SUCCESS, VERIFY_USER_OTP_SUCCESS, DELETE_OTP_SECRET_DATA_SUCCESS,
  EXPORT_USER_SETTINGS_SUCCESS, RESET_USER_SETTINGS_EXPORT_FILE, VERIFY_USER_PHONE_SUCCESS,
} from '../../../constants/system/actions';

const settingsUserReducer: Reducer = (
  state: ReducerState = {
    userSettingsData: null,
    actionHash: null,
    userSettingsExportFile: null,
    userApiKey: null,
    otpSecretQrCodeLink: null,
    otpSecretHash: null,
    formErrors: {},
    isFormSaving: false,
  },
  action: ReduxAction,
): ReducerState => {
  switch (action.type) {
    case GET_USER_SETTINGS_DATA_SUCCESS:
      return {
        ...state,
        userSettingsData: action.data,
      };
    case GET_USER_API_KEY_SUCCESS:
      if (!action.payload || !action.payload.userId || !action.data.apiKey) {
        return state;
      }

      return {
        ...state,
        userApiKey: action.data.apiKey,
      };
    case GET_OTP_SECRET_DATA_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        otpSecretQrCodeLink: action.data.qrCodeLink,
        otpSecretHash: action.data.hash,
      };
    case EXPORT_USER_SETTINGS_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        userSettingsExportFile: action.data.file,
      };
    case GENERATE_OTP_SECRET_DATA_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        userSettingsData: {
          ...state.userSettingsData,
          userData: {
            ...state.userSettingsData.userData,
            isOtpEnabled: true,
          },
        },
        otpSecretQrCodeLink: action.data.qrCodeLink,
        otpSecretHash: action.data.hash,
      };
    case VERIFY_USER_OTP_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        userSettingsData: {
          ...state.userSettingsData,
          userData: {
            ...state.userSettingsData.userData,
            isOtpEnabled: true,
            isOtpVerified: true,
          },
        },
        otpSecretQrCodeLink: null,
        otpSecretHash: null,
      };
    case DELETE_OTP_SECRET_DATA_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        userSettingsData: {
          ...state.userSettingsData,
          userData: {
            ...state.userSettingsData.userData,
            isOtpEnabled: false,
            isOtpVerified: false,
            isVerificationRequired: !state.userSettingsData.userData.isPhoneVerified ? false
              : state.userSettingsData.userData.isVerificationRequired,
            verificationTypeDefault: (
              state.userSettingsData.userData.verificationTypeDefault === VERIFICATION_TYPE_AUTHENTICATOR_APP_OTP
                ? null : state.userSettingsData.userData.verificationTypeDefault
            ),
          },
        },
        otpSecretQrCodeLink: null,
        otpSecretHash: null,
      };
    case SEND_PHONE_VERIFICATION_CODE_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        actionHash: action.data.actionHash,
      };
    case VERIFY_USER_PHONE_SUCCESS:
      if (!action.payload || !action.payload.userId) {
        return state;
      }

      return {
        ...state,
        userSettingsData: {
          ...state.userSettingsData,
          userData: {
            ...state.userSettingsData.userData,
            isPhoneVerified: true,
          },
        },
      };
    case SAVE_USER_SETTINGS_DATA:
      return {
        ...state,
        formErrors: {},
        isFormSaving: true,
      };
    case SAVE_USER_SETTINGS_DATA_SUCCESS:
      return {
        ...state,
        userSettingsData: action.data.userSettingsData,
        formErrors: {},
        isFormSaving: false,
      };
    case SAVE_USER_SETTINGS_DATA_ERROR:
      if (!action.error) {
        return {
          ...state,
          isFormSaving: false,
        };
      }

      return {
        ...state,
        formErrors: ErrorFormatService.isFormError(action.error)
          ? ErrorFormatService.formatGraphQLErrors({ ...action.error })
          : ErrorFormatService.formatGraphQLMainError({ ...action.error }),
        isFormSaving: false,
      };
    case GET_LIST_CONTACT_COMPANY_DATA_SUCCESS:
      if (!state.userSettingsData) {
        return state;
      }

      return {
        ...state,
        userSettingsData: {
          ...state.userSettingsData,
          contactCompanyList: action.data,
        },
      };
    case GET_LIST_DEAL_DATA_SUCCESS:
      if (!state.userSettingsData) {
        return state;
      }

      return {
        ...state,
        userSettingsData: {
          ...state.userSettingsData,
          dealList: action.data,
        },
      };
    case RESET_USER_SETTINGS_DATA:
      return {
        ...state,
        userSettingsData: null,
        formErrors: {},
        isFormSaving: false,
      };
    case RESET_USER_SETTINGS_EXPORT_FILE:
      return {
        ...state,
        userSettingsExportFile: null,
      };
    case RESET_USER_API_KEY:
      return {
        ...state,
        userApiKey: null,
      };
    case RESET_FORM_ERRORS:
      return {
        ...state,
        formErrors: {},
      };
    case LOGIN_USER_SUCCESS:
    case LOGOUT_USER_SUCCESS:
      return {
        ...state,
        userSettingsData: null,
        actionHash: null,
        userSettingsExportFile: null,
        userApiKey: null,
        otpSecretQrCodeLink: null,
        otpSecretHash: null,
        formErrors: {},
        isFormSaving: false,
      };
    default:
      return state;
  }
};

export default settingsUserReducer;
